if (!customElements.get('yc-blessing6')) {
  class YcBlessing6 extends HTMLElement {
    connectedCallback() {
      setTimeout(() => {
        this.settings = JSON.parse(this.getAttribute('data-settings') || '{}');
        this.initAudio();
      }, 0);
    }

    disconnectedCallback() {
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
      }
    }

    initAudio() {
      this.triggerEl = this.querySelector('.js-audio-trigger');
      this.iconEl = this.querySelector('.js-audio-icon');

      if (!this.triggerEl || !this.iconEl) return;

      const audioUrl = this.getAttribute('data-audio-url') || '';
      if (!audioUrl) {
        this.triggerEl.classList.add('is-disabled');
        return;
      }

      this.audio = new Audio(audioUrl);
      this.audio.loop = true;
      this.audio.crossOrigin = 'anonymous';
      this.audio.preload = 'none';

      this.isPlaying = false;
      this.isLoading = false;

      this.triggerEl.addEventListener('click', () => {
        if (this.isPlaying) {
          this.pause();
        } else {
          this.play();
        }
      });

      this.audio.addEventListener('waiting', () => {
        this.isLoading = true;
        this.updateIcon();
      });

      this.audio.addEventListener('canplay', () => {
        this.isLoading = false;
        this.updateIcon();
      });

      this.audio.addEventListener('playing', () => {
        this.isLoading = false;
        this.isPlaying = true;
        this.updateIcon();
      });

      this.audio.addEventListener('pause', () => {
        this.isPlaying = false;
        this.updateIcon();
      });
    }

    play() {
      if (!this.audio) return;
      this.isLoading = true;
      this.updateIcon();
      this.audio.play().catch((e) => {
        console.error('Play failed', e);
        this.isLoading = false;
        this.isPlaying = false;
        this.updateIcon();
      });
    }

    pause() {
      if (!this.audio) return;
      this.audio.pause();
    }

    updateIcon() {
      if (this.isLoading) {
        this.iconEl.innerHTML = `
          <svg class="icon-loading" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="2" x2="12" y2="6"></line>
            <line x1="12" y1="18" x2="12" y2="22"></line>
            <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
            <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
            <line x1="2" y1="12" x2="6" y2="12"></line>
            <line x1="18" y1="12" x2="22" y2="12"></line>
            <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
            <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
          </svg>
        `;
      } else if (this.isPlaying) {
        this.iconEl.innerHTML = `
          <svg class="icon-pause" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="6" y="4" width="4" height="16"></rect>
            <rect x="14" y="4" width="4" height="16"></rect>
          </svg>
        `;
      } else {
        this.iconEl.innerHTML = `
          <svg class="icon-play" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="5 3 19 12 5 21 5 3"></polygon>
          </svg>
        `;
      }
    }
  }

  customElements.define('yc-blessing6', YcBlessing6);
}
